import Inflect from 'i'

const inflect = Inflect()

export default (string = '') => {
  return inflect.singularize(string)
}
